const snippets = (state) => state.snippets;
const snippet = (state) => state.snippet;
const editSnippet = (state) => state.editSnippet;
const activeSnippetIds = (state) => state.activeSnippetIds;
const activeSnippetHashes = (state) => state.activeSnippetHashes;
const snippetExistsArray = (state) => state.snippetExistsArray;
const modalSnippet = (state) => state.modalSnippet;
const modalConfirm = (state) => state.modalConfirm;
const hit = (state) => state.hit;
const hitIdx = (state) => state.hitIdx;
const pageNum = (state) => state.pageNum;
const query = (state) => state.query;
const mode = (state) => state.mode;
const filters = (state) => state.filters;
const actionDateEnd = (state) => state.actionDateEnd;
const actionDateStart = (state) => state.actionDateStart;
const isSavingSnippetLoading = (state) => state.isSavingSnippetLoading;
const isDestroyingSnippetLoading = (state) => state.isDestroyingSnippetLoading;

export const getters = {
  snippets,
  modalSnippet,
  hit,
  hitIdx,
  pageNum,
  query,
  filters,
  actionDateStart,
  actionDateEnd,
  snippet,
  editSnippet,
  modalConfirm,
  mode,
  activeSnippetIds,
  activeSnippetHashes,
  snippetExistsArray,
  isSavingSnippetLoading,
  isDestroyingSnippetLoading,
};
